import { Component, Prop, Vue } from "vue-property-decorator";
import throttle from "lodash/throttle";

type Position = {
    left: number;
    top: number;
};
@Component
export default class DragTool extends Vue {
    dragActive: boolean = false; // 是否激活拖拽功能
    tempDrag: boolean = false; // 少部分场景下需暂时开启拖拽功能
    dragElement: HTMLElement; // 拖拽操作对象
    moveElement: HTMLElement; // 拖拽应用对象

    nowPositon: Position = {
        left: 0,
        top: 0,
    };
    isMoving: boolean;
    limitMove: boolean = true; // 限制移动区域于屏幕内
    elementWidth: number = 0;
    elementHeight: number = 0;

    minX: number | null = 0;
    minY: number | null = this.topbarHeight;
    maxX: number | null = window.innerWidth;
    maxY: number | null = window.innerHeight;

    getStyle(dom, attr) {
        return dom.currentStyle ? dom.currentStyle[attr] : getComputedStyle(dom)[attr];
    }

    getNowPosition(dom) {
        return {
            left: parseInt(this.getStyle(dom, "left")) || 0,
            top: parseInt(this.getStyle(dom, "top")) || 0,
        };
    }

    setPosition(dom) {
        this.nowPositon["left"] = parseInt(this.getStyle(dom, "left")) || 0;
        this.nowPositon["top"] = parseInt(this.getStyle(dom, "top")) || 0;
    }

    updatePosition(dom, x, y) {
        dom.style.left = x + "px";
        dom.style.top = y + "px";
    }

    updatePositionAnimation(dom, startData, endData, duration = 150) {
        let start;
        let step = (timestamp) => {
            !start && (start = timestamp);
            const stepp = Math.min((timestamp - start) / duration, 1);
            const changeX = startData.x + stepp * (endData.x - startData.x);
            const changey = startData.y + stepp * (endData.y - startData.y);
            this.updatePosition(dom, changeX, changey);
            if (stepp != 1) {
                window.requestAnimationFrame(step);
            }
        };
        window.requestAnimationFrame(step);
    }

    setTempDrag(status) {
        this.tempDrag = status;
    }

    setSafeArea(opt: { minX?: number; minY?: number; maxX?: number; maxY?: number }) {
        const { minX, minY, maxX, maxY } = opt;
        if (typeof minX === "number") this.minX = minX;
        if (typeof minY === "number") this.minY = minY;
        if (typeof maxX === "number") this.maxX = maxX;
        if (typeof maxY === "number") this.maxY = maxY;
    }

    drag(a, t) {
        let rect = this.moveElement.getBoundingClientRect();
        a.onmousedown = (e) => {
            e.preventDefault();
            if (!this.dragActive && !this.tempDrag) return;
            this.setPosition(t);
            this.elementWidth = rect.width;
            this.elementHeight = rect.height;
            let moveL = null,
                moveT = null,
                timer = 0;
            timer = setTimeout(() => {
                this.isMoving = true;
                clearTimeout(timer);
            }, 180);
            document.onmousemove = throttle((b) => {
                b.preventDefault();
                if (!this.isMoving) return;
                var x = b.clientX - e.clientX;
                var y = b.clientY - e.clientY;
                (moveL = x + this.nowPositon["left"]), (moveT = y + this.nowPositon["top"]);
                let fixX = this.getMoveX(moveL);
                let fixY = this.getMoveY(moveT);
                this.updatePosition(t, fixX, fixY);
            }, 16);
            document.onmouseup = () => {
                setTimeout(() => {
                    this.isMoving = false;
                }, 180);
                this.setPosition(t);
                document.onmouseup = null;
                document.onmousemove = null;
            };
        };
    }

    getMoveX(x) {
        let fitX = x;
        if (this.limitMove) {
            if (x < this.minX) {
                fitX = this.minX;
            } else if (x > this.maxX - this.elementWidth) {
                fitX = this.maxX - this.elementWidth;
            }
        }
        return fitX;
    }

    get topbarHeight() {
        return this.$store.state.ui.sceneTop;
    }

    getMoveY(y) {
        let fitY = y;
        if (this.limitMove) {
            if (y < this.minY) {
                fitY = this.minY;
            } else if (y > this.maxY - this.elementHeight) {
                fitY = this.maxY - this.elementHeight;
            }
        }
        return fitY;
    }
}
